import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-section border-y border-line" data-id="element-78" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-79" data-mp="1cft3rt6n8vw5">
        <div className="text-center mb-16" data-id="element-80" data-mp="1ccnfgg5u9y1h">
          <p className="text-gold font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-81" data-mp="2a179eoa8d30x">
            Everything you need to know
          </p>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white" data-id="element-82" data-mp="2512peoa45q5y">
            Frequently asked questions
          </h2>
        </div>
        <div className="space-y-3" data-id="element-83" data-mp="1v5r941j24aw3">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-card border border-line rounded-xl overflow-hidden" data-id="element-84" data-mp="oonphigcqbny" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-inset" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-85" data-mp="jq2nbdhjhhwv">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86" data-mp="1arx0bi0kiucq">{faq.q}</span>
                <ChevronDown className={`text-gold transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-87" data-mp="1fqqdf9by0jcd" />
              </button>
              <AnimatePresence initial={false} data-id="element-88" data-mp="s0ma732o2llw">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-89" data-mp="wynrpjkg2cv9">
                    <div className="px-6 pb-5 text-mist border-t border-line pt-4" data-id="element-90" data-mp="2kvwzukg27v5z">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}